//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../no/TaggedObject.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
let d=[[[1,"EndLocation",0,"GeometricUtilities.OnPathDimensionBuilder",0],[1,"FemaleLeftRadius",0,"Expression",0],[1,"FemaleRightRadius",0,"Expression",0],[0,"Flow",1,0],[1,"MaleBeadHeight",0,"Expression",0],[0,"MaleBeadWidthType",1,0],[1,"MaleLeftSheetRadius",0,"Expression",0],[1,"MaleLeftTopRadius",0,"Expression",0],[1,"MaleLeftWallAngle",0,"Expression",0],[1,"MaleLeftWidth",0,"Expression",0],[1,"MaleRightSheetRadius",0,"Expression",0],[1,"MaleRightTopRadius",0,"Expression",0],[1,"MaleRightWallAngle",0,"Expression",0],[1,"MaleRightWidth",0,"Expression",0],[1,"MaleTransitionLength",0,"Expression",0],[1,"StartLocation",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"Symmetry",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Die.DrawBeadSegmentBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.DrawBeadSegmentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Die.DrawBeadSegmentBuilder.MaleBeadWidthTypes = Object.freeze({
    "Constant" : "Constant", "Derived" : "Derived"});

export default SPLM;